jQuery(document).ready(function($) {
  function initMobileSlider() {
    if ($(window).width() <= 767) {
      if (!$('.multiple-slider').hasClass('slick-initialized')) {
        $('.multiple-slider').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        });
      }
    } else {
      if ($('.multiple-slider').hasClass('slick-initialized')) {
        $('.multiple-slider').slick('unslick');
      }
    }
  }

  // Initial check
  initMobileSlider();

  // On window resize
  $(window).on('resize', function() {
    initMobileSlider();
  });
  // instructor slider
  $('.instructor-slider').slick({
  dots: true,
    arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1026,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});
